export default __webpack_public_path__ + "static/c_kollert-99c3a7c524b94fadbeefedd450251aba.jpg";